import { render, staticRenderFns } from "./ShareCampaignModal.vue?vue&type=template&id=89dec562&scoped=true&"
import script from "./ShareCampaignModal.vue?vue&type=script&lang=ts&"
export * from "./ShareCampaignModal.vue?vue&type=script&lang=ts&"
import style0 from "./ShareCampaignModal.vue?vue&type=style&index=0&id=89dec562&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dec562",
  null
  
)

export default component.exports